import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";
import CodeBlockDefaultExample, { vehicleEmissionsBibtex } from "./codeBlock.js";

class Research extends React.Component {
  render() {
    const accentLinkStyle = { color: "#168f7c", textDecoration: "none" };

    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="row">
            <div className="mt-3" id="research">
              <h5>Research</h5>
              <hr />

              <ul className="list-group">
                {/* Paper 1 */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>
                        Is Programming Relevant to CS1 Students’ Interests?
                      </h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        Journal of Computing Sciences in Colleges (JCSC), 2021
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          <strong>Authors:</strong> Kevin Buffardi, Subhed
                          Chavan
                        </li>
                        <li>
                          Peer reviewed research study analyzing how
                          introductory programming courses align with student
                          interests and motivation.
                        </li>
                        <li>
                          Focused on empirical data collection, survey design,
                          and statistical analysis to evaluate student
                          engagement in CS1 curricula.
                        </li>
                        <li>
                          Findings informed curriculum design decisions aimed at
                          improving retention and learning outcomes in computer
                          science education.
                        </li>
                        <li>
                          Published via the{" "}
                          <a
                            href="https://dl.acm.org/doi/10.5555/3512469.3512475"
                            target="_blank"
                            rel="noreferrer"
                            style={accentLinkStyle}
                          >
                            ACM Digital Library
                          </a>
                        </li>
                        <li>
                          <strong>Citation:</strong>
                          <br />
                          Kevin Buffardi and Subhed Chavan. 2021. Is programming
                          relevant to CS1 students’ interests? Journal of
                          Computing Sciences in Colleges, 37(1), 45–53.
                        </li>
                        <li>
                          <strong>BibTeX:</strong>
                          <div className="mt-2">
                            <CodeBlockDefaultExample />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                {/* Paper 2 */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>
                        Remote Sensing Technique for Monitoring and Reducing
                        Harmful Gas Emissions from Vehicles
                      </h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        International Journal of Research and Analytical Reviews
                        (IJRAR)
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          <strong>Authors:</strong> Subhed Chavan, Sahil Shetty,
                          Sidharth Chandran, Anindita Khade
                        </li>
                        <li>
                          Designed a remote sensing based system to monitor
                          vehicular emissions and automate pollution data
                          collection.
                        </li>
                        <li>
                          Combined hardware sensors with backend systems to
                          capture, process, and transmit emission data.
                        </li>
                        <li>
                          Explored scalable approaches for regulatory reporting
                          and environmental monitoring using automated data
                          pipelines.
                        </li>
                        <li>
                          Full paper available via{" "}
                          <a
                            href="https://www.ijrar.org/viewfull.php?&p_id=IJRAR19H1217"
                            target="_blank"
                            rel="noreferrer"
                            style={accentLinkStyle}
                          >
                            IJRAR
                          </a>
                        </li>
                        <li>
                          <strong>Citation:</strong>
                          <br />
                          Subhed Chavan, Sahil Shetty, Sidharth Chandran, and
                          Anindita Khade. 2019. Remote Sensing Technique for
                          Monitoring and Reducing Harmful Gas Emissions from
                          Vehicles. International Journal of Research and
                          Analytical Reviews, 6(1), 453–457.
                        </li>
                        <li>
                          <strong>BibTeX:</strong>
                          <div className="mt-2">
                            <CodeBlockDefaultExample
                              text={vehicleEmissionsBibtex}
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Research;
